function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  transform: "translate(1 1)"
}, React.createElement("path", {
  d: "M11.0873016.436507937L.523809524 9.95238095M11.0873016 20.515873L.523809524 9.95238095"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    className: "icon",
    viewBox: "0 0 13 23",
    style: {
      "height": "1em",
      "width": "0.56522em"
    }
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/right-arrow.1aa1b263.svg";
export { SvgComponent as ReactComponent };